module.exports = __webpack_public_path__ + "static/media/video.aa49fb22.svg";